import React from "react";

import { Link, useLocation } from "react-router-dom";
import styled from "styled-components";

import SidebarItem from "./SideBarItem";

import { House,  Calculator, Gear, BoxArrowRight } from 'react-bootstrap-icons';

const SidebarArea = styled.div `
  width: 60px;
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 45px;
  left: 0;
  text-align: center ;
  height: 100vh;
  align-items: center;
  justify-content: top; 
  background-color: rgb(212, 215, 228);
` 

function Sidebar() {

  // URL의 path값을 받아올 수 있다.
  const pathName = useLocation().pathname;
  if ( pathName === '/login') return null;

  const menus = [
    { name: "HOME", path: "/" , icon: House },
    { name: "매출현황", path: "/sales_status" , icon: Calculator},
   // { name: "매출집계", path: "/sales_management" },
    { name: "장치관리", path: "/device_management" , icon: Gear},
    //{ name: "설정", path: "/settings" },
    { name: "LOGOUT", path: "/login" , icon: BoxArrowRight},
  ];

  return (
    <SidebarArea>
      {menus.map((menu, index) => {
        return (
          <Link to={menu.path} key={index}>
            <SidebarItem
              menu={menu}
              isActive={pathName === menu.path ? true : false}
            />            
          </Link>
        );
      })}
    </SidebarArea>
  );
}

export default Sidebar;
